export const IRootScreenViewModelType = Symbol('IRootScreenViewModel');
